import RxQuery from 'utils/api/rxQuery/rxQuery';
import endpoints from 'utils/api/endpoints';
import * as payloads from 'utils/api/payloads/omantelMicroApi';
import { getLanguage } from 'utils/language/language';

const microApi = () => new RxQuery('omantelMicroApi');

//This API is for adding new microbundle for new customer and also for activating the selected services for the returning customer.
export const submitSalesLeads = (data: payloads.SubmitSalesLeads) => {
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.microbundleService)
		.setPayload(data)
		.setCustomHeaders()
		.disableCache();
};

//API to check if customer is Riyada customer or not, crNumber is the documentId for the selected organization.
export const riyadaCustomerIdentifier = (crNumber: number, isBomOn: boolean) => {
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.isRiyadaCustomer.isRiyadaCustomer({ crNumber }))
		.setCustomHeaders()
		.setHeaders('x-requires-bm-details', isBomOn);
};

// get service status and service information about microbundle additional benefits
export const geMicrobundleServiceInfo = (data: payloads.ServiceInfo) => {
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.microbundleServiceInfo)
		.setPayload(data)
		.setCustomHeaders()
		.disableCache();
};

// get service status and service information about microbundle additional benefits
export const bandwidthOnDemand = (data: payloads.BandwidthOnDemand) => {
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.fbbProBandwidthOnDemand)
		.setPayload(data)
		.setCustomHeaders()
		.disableCache();
};

// api to submit request for bandwidth on demand
export const bandwidthOnDemandSubmitRequest = (data: payloads.BandwidthOnDemand) => {
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.fbbProBandwidthOnDemandSubmitRequest)
		.setPayload(data)
		.setCustomHeaders()
		.disableCache();
};

// api to change fbb plan
export const changeFbbOrder = (data: payloads.ChangeFbbOrder) => {
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.changeFbbOrder)
		.setCustomHeaders()
		.setPayload(payloads.changeFbbOrder({ ...data }));
};
// api to create fiber pro plan
export const createFbbOrder = (data: payloads.CreateFbbOrder, isFiberPro2b: boolean) => {
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.createFbbOrder.createFbbOrder(isFiberPro2b))
		.setCustomHeaders()
		.setPayload(payloads.createFbbOrder({ ...data }));
};

//api to get order summary
export const getFbbOrderSummary = (data: payloads.FbbOrderSummary) => {
	const lang = getLanguage();
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.getFbbOrderSummary)
		.setCustomHeaders()
		.setPayload(payloads.getFbbOrderSummary({ ...data }));
};

// API to get all notifications
export const getNotificationsRest = (limit: number) => {
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.getNotifications(limit))
		.setCustomHeaders()
		.setHeaders('x-device-id', 'EBU')
		.setCustomerId();
};

export const readAllNotifications = () => {
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.readAllNotifications)
		.setPayload({ notificationIds: null })
		.setCustomHeaders()
		.setHeaders('x-device-id', 'EBU')
		.setCustomerId();
};

export const readNotification = (notificationId: string) => {
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.readNotification(notificationId))
		.setCustomHeaders()
		.setHeaders('x-device-id', 'EBU')
		.setCustomerId();
};

//API to check if username is available or
export const validateUserName = (userName: string) => {
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.validateUserName.validateUserName(userName))
		.setCustomHeaders();
};

//api to get booster plans
export const getBoosterPlans = (subscriberNumber: string, isCopperUser: boolean, productId?: string) => {
	const lang = getLanguage();
	return microApi()
		.setEndpoint(endpoints.omantelMicroApi.getBoosterOffer.getBtlPlans(subscriberNumber, isCopperUser, productId))
		.setCustomHeaders();
};
// new subscribe product api
export const getSubscriberProducts = (phoneNumber: string, billingType: string, accountType: string) => {
	return microApi()
		.setEndpoint(
			endpoints.omantelMicroApi.subscriberProducts.getSubscriberProducts(phoneNumber, billingType, accountType)
		)
		.setInvalidateKey('getSubscriberProducts')
		.setCustomHeaders()
		.setType('subscriberProducts');
};

export const getPaymentTokens = () => {
	return microApi()
		.setEndpoint(endpoints.microApi.bills.getPaymentTokens)
		.setInvalidateKey('getPaymentTokens');
};

export const getPaymentSummary = () => {
	return microApi()
		.setEndpoint(endpoints.omantelApi.getPaymentSummary)
		.setInvalidateKey('getPaymentSummary');
};

//api to get payment status of BOM
export const getPaymentsRequestStatus = (
	pageNumber: number = 0,
	pageSize: number = 10,
	fromDate: string,
	toDate: string,
	paymentStatus: string,
	billNumber: string
) => {
	return microApi()
		.setEndpoint(
			endpoints.omantelApi.getPaymentsRequestStatus.getPaymentRequestStatus(
				pageNumber,
				pageSize,
				fromDate,
				toDate,
				paymentStatus,
				billNumber
			)
		)
		.disableCache();
};

//api to get refresh payment status
export const getRefreshPayment = () => {
	return microApi().setEndpoint(endpoints.omantelApi.getRefreshPayment);
};

//api to fetch payment history
export const fetchPaymentHistory = (fromDate: string, toDate: string) => {
	return microApi().setEndpoint(endpoints.omantelApi.fetchPaymentHistory(fromDate, toDate));
};
export const makeBOMPayment = () => {
	return microApi()
		.setEndpoint(endpoints.omantelApi.makeBOMPayment)
		.disableCache();
};

export const deletePaymentToken = (tokenType: string, id: string) => {
	return microApi()
		.setEndpoint(endpoints.omantelApi.deletePaymentToken(tokenType, id))
		.disableCache();
};
